"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListSelector = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
const _contracts_1 = require("../../_contracts");
const services_1 = require("../../../services");
const ListSelection_contracts_1 = require("./ListSelection.contracts");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
let ListSelector = class ListSelector extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.description = null;
        this.hasErrors = false;
        this.isDescribing = true;
        this.icons = backoffice_1.DashmixIconName;
        this.listVariants = ListSelection_contracts_1.ListSelectionMode;
        this.moduleModes = _contracts_1.ModuleMode;
    }
    get isListDefined() {
        return !!this.related && typeof this.related.value !== 'undefined';
    }
    mounted() {
        if (this.isListDefined) {
            this.$nextTick(() => {
                this.setVariant(this.related);
            });
            if (!this.variant || this.variant === ListSelection_contracts_1.ListSelectionMode.Default) {
                this.describe(this.related);
            }
        }
    }
    changeVariant(value) {
        this.variant = value;
        if (value === ListSelection_contracts_1.ListSelectionMode.Auto) {
            this.related = { type: services_1.RelatedType.Set, value: '##LIST_ID##' };
            this.isDescribing = false;
        }
        else if (value === ListSelection_contracts_1.ListSelectionMode.Parent) {
            this.related = { type: services_1.RelatedType.Set, value: '$parent' };
            this.isDescribing = false;
        }
        else {
            this.related = null;
        }
    }
    clearList() {
        this.related = null;
    }
    findList() {
        this.pickRelated(services_1.Picker.Set, this.setList);
    }
    variantOptions() {
        const options = [{
                label: `${this.$t('forms.shared.selectionModes.default')}`,
                value: ListSelection_contracts_1.ListSelectionMode.Default
            }];
        if (this.mode === _contracts_1.ModuleMode.Layout) {
            options.push({
                label: `${this.$t('forms.shared.selectionModes.parent')}`,
                value: ListSelection_contracts_1.ListSelectionMode.Parent
            });
        }
        if (this.mode === _contracts_1.ModuleMode.Smart) {
            options.push({
                label: `${this.$t('forms.shared.selectionModes.auto')}`,
                value: ListSelection_contracts_1.ListSelectionMode.Auto
            });
        }
        return options;
    }
    describe(source) {
        this.isDescribing = true;
        this.relatedService.describe(source).then((list) => {
            this.description = list;
        }).catch((error) => {
            console.warn(error);
            this.description = { title: this.$t('listSelector.noTitle'), totalItems: 0 };
            this.hasErrors = true;
        }).finally(() => {
            this.isDescribing = false;
        });
    }
    onDuplicatesValueChange() {
        if (!this.related) {
            return;
        }
        if (this.duplicates) {
            this.related.type = services_1.RelatedType.Set;
        }
        else {
            this.related.type = services_1.RelatedType.DeduplicatedSet;
        }
    }
    setList(source) {
        if (!this.duplicates) {
            source.type = services_1.RelatedType.DeduplicatedSet;
        }
        this.describe(source);
        this.related = source;
    }
    setVariant(related) {
        switch (related.value) {
            case '$parent':
                this.variant = ListSelection_contracts_1.ListSelectionMode.Parent;
                this.isDescribing = false;
                break;
            default:
                if (this.mode === this.moduleModes.Smart) {
                    this.variant = ListSelection_contracts_1.ListSelectionMode.Auto;
                }
                else {
                    this.variant = ListSelection_contracts_1.ListSelectionMode.Default;
                }
                this.isDescribing = false;
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], ListSelector.prototype, "canBeCleared", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], ListSelector.prototype, "duplicates", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: true }),
    __metadata("design:type", String)
], ListSelector.prototype, "mode", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Function, required: true }),
    __metadata("design:type", Function)
], ListSelector.prototype, "pickRelated", void 0);
__decorate([
    vue_property_decorator_1.PropSync('list', { type: Object, required: false, default: null }),
    __metadata("design:type", Object)
], ListSelector.prototype, "related", void 0);
__decorate([
    vue_property_decorator_1.PropSync('listType', { type: String, required: false }),
    __metadata("design:type", String)
], ListSelector.prototype, "variant", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false }),
    __metadata("design:type", Object)
], ListSelector.prototype, "relatedService", void 0);
__decorate([
    vue_property_decorator_1.Watch('duplicates'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ListSelector.prototype, "onDuplicatesValueChange", null);
ListSelector = __decorate([
    vue_property_decorator_1.Component({
        name: 'ListSelector',
        components: { DashmixButton: backoffice_1.DashmixButton, DashmixIcon: backoffice_1.DashmixIcon, DashmixSelect: backoffice_1.DashmixSelect },
        template: `
  <div class="row">
    <div class="col-4" v-if="mode !== moduleModes.Default">
      <DashmixSelect :model="variant" @update:model="changeVariant" :options="variantOptions()" />
    </div>

    <div class="col-4" v-if="!isListDefined && variant === listVariants.Default">
      <DashmixButton variant="alt" :icon="icons.SearchSolid" :label="$t('forms.shared.add')" @click="findList" />
    </div>

    <div class="col">
      <p class="mt-2 mb-0" v-if="isListDefined">
        <strong class="mr-2">{{ $t('forms.shared.chosenSource') }}</strong>
        <span v-if="isDescribing "><DashmixIcon :icon="icons.SpinnerSolid" spin /></span>
        <span v-else-if="variant === listVariants.Default && description">{{ description.title }} ({{ description.totalItems || 'x' }})</span>
        <span v-else>{{ variant === listVariants.Auto ? $t('forms.shared.listVariant.auto') : $t('forms.shared.listVariant.parent') }}</span>
      </p>
    </div>
    <div class="col-3 text-right" v-if="isListDefined && variant === listVariants.Default">
      <DashmixButton :loading="isDescribing" variant="alt" :icon="icons.PenSolid" :label="$t('forms.shared.change')"
                     @click="findList" />
      <DashmixButton v-if="canBeCleared" :loading="isDescribing" theme="danger" variant="alt" :icon="icons.TrashSolid"
                     @click="clearList" />
    </div>
  </div>
  `
    })
], ListSelector);
exports.ListSelector = ListSelector;
//# sourceMappingURL=ListSelector.form.js.map